export const filters = [
  {
    key: "location_title",
    title: "Location Title",
    type: "text",
  },
  {
    key: "width",
    title: "Width",
    type: "text",
  },
  {
    key: "height",
    title: "Height",
    type: "text",
  },
  {
    key: "box_color",
    title: "Box Color",
    type: "text",
  },
  {
    key: "text",
    title: "Text",
    type: "text",
  },
  {
    key: "font_size",
    title: "Font Size",
    type: "text",
  },
  {
    key: "font_height",
    title: "Font Height",
    type: "text",
  },
  {
    key: "type",
    title: "Type",
    type: "text",
  },
  {
    key: "bg_color",
    title: "Background Color",
    type: "text",
  },
  {
    key: "bg_path",
    title: "Background Path",
    type: "text",
  },
  {
    key: "font_style",
    title: "Font Style",
    type: "text",
    is_schema_object: true,
  },
  {
    key: "text_color",
    title: "Text Colour",
    type: "text",
  },
];

export const defaultFilters = {
  image_size: {
    title: "Post (1080 x 1080)",
    width: 1080,
    height: 1080,
  },
  width: 1080,
  height: 1080,

  // Text
  location_title: "",
  text: "",
  font_style: {
    title: "Open Sans",
    value: "OpenSans_SemiCondensed-SemiBold",
  },
  text_color: "#16191f",

  // Size
  font_size: 24,
  font_height: 16,

  // Color
  type: "Colour",
  box_color: `#ffffff`,
  bg_color: "#16191f",
  bg_path: "",
};

export const staticFilters = {
  image_size: {
    title: "Post (1080 x 1080)",
    width: 1080,
    height: 1080,
  },
  width: 1080,
  height: 1080,

  // Text
  location_title: "",
  text: "",
  font_style: {
    title: "Open Sans",
    value: "OpenSans_SemiCondensed-SemiBold",
  },
  text_color: "#16191f",

  // Size
  font_size: 24,
  font_height: 16,

  // Color
  type: "Colour",
  box_color: `#ffffff`,
  bg_color: "#16191f",
  bg_path: "",
};

export const sizeSettings = {
  sliders: [
    {
      key: "font_size",
      title: "Font Size",
      min: 12,
      max: 64,
    },
    {
      key: "font_height",
      title: "Font Height",
      min: 12,
      max: 64,
    },
  ],
  hex: [],
  boolean: [],
  select: [],
};

export const colorSettings = {
  sliders: [],
  hex: [
    {
      key: "box_color",
      title: "Box Colour",
    },
    {
      key: "bg_color",
      title: "Background Colour",
    },
    {
      key: "text_color",
      title: "Text Colour",
    },
  ],
  boolean: [],
  select: [],
};

export const imageSize = [
  {
    title: "Landscape (1200 x 630)",
    width: 1200,
    height: 630,
  },
  {
    title: "Post (1080 x 1080)",
    width: 1080,
    height: 1080,
  },
  {
    title: "Story (1080 x 1920)",
    width: 1080,
    height: 1920,
  },
];

export const fontFamily = [
  {
    title: "Open Sans",
    value: "OpenSans_SemiCondensed-SemiBold",
  },
  {
    title: "Old Standard TT",
    value: "OldStandardTT-Regular",
  },
  {
    title: "PT Serif",
    value: "PTSerif-Regular",
  },
  {
    title: "Montserrat",
    value: "Montserrat-VariableFont_wght",
  },
  {
    title: "Lato",
    value: "Lato-Light",
  },
  {
    title: "Nunito",
    value: "Nunito-VariableFont_wght",
  },
  {
    title: "Poppins",
    value: "Poppins-SemiBold",
  },
  {
    title: "Spectral",
    value: "Spectral-SemiBold",
  },
  {
    title: "Lora",
    value: "Lora-VariableFont_wght",
  },
  {
    title: "Kalam",
    value: "Kalam-Regular",
  },
];

export const bgTypes = ["Colour", "Review Image", "Pattern Image"];
